import ConfirmarExclusao from 'global/guides/Dialog/ConfirmarExclusao'
import { useTrocaTabelaHorarioContext } from 'pages/TrocaTabelaHorarios.context'
import { useParams } from 'react-router-dom'
import { tabelaHorarios, trocaHorario } from 'service/api'
import { toast } from 'sonner'
import { encontrarTroca } from './encontrar-troca'

export default function ExcluirTrocaTabelaHorario() {
    const { id } = useParams<{ id: string }>()
    const { data } = useTrocaTabelaHorarioContext()
    const { mutateAsync, isLoading } =
        tabelaHorarios.funcionario.mutations.useDelete({
            invalidateQuery: true,
        })

    const tabela = encontrarTroca(data, id)
    if (!tabela || tabela.isTrocaAutomatica) return null

    function handleSubmit() {
        return mutateAsync(Number(tabela!.id), {
            onSuccess: () => {
                toast.success('Tabela removida com sucesso!')
                trocaHorario.invalidateQueries()
            },

            onError: err => {
                toast.error(err.message)
            },
        })
    }

    return (
        <ConfirmarExclusao
            permissao={['delete', 'TrocaDeTabelaDeHorário']}
            loading={isLoading}
            onConfirm={handleSubmit}
            title="Tem certeza que deseja excluir a troca de tabela?"
        />
    )
}
